import { RegisteredTokenDetail, RegisteredTokenResponse } from "models/factory/RegisteredTokenResponse";
import { TokenInfoResponse } from "models/token/TokenInfoResponse";
import React, { useEffect, useState } from "react";
import { FACTORY_ADDRESS, VERIFIED_TOKENS_URL } from "utils/Constants";
import { CosmWasmClient } from "cosmwasm";
import { TokenItem } from "components/TokenItem";
import { showLoadingToast } from "utils/Toasts";
import { ConfigResponse } from "models/staking/ConfigResponse";
import { copy, getTokenDetails, numberPendek, saveTokenDetails } from "utils/Helpers";
import { TokenDetailForm } from "components/TokenDetailForm";
import { showTokenDetailModal } from "utils/Modals";
import { PoolResponse } from "models/staking/PoolResponse";
import { querySmartContract } from "utils/RpcHelpers";

type TokenDetail = { tokenInfo: TokenInfoResponse, config: ConfigResponse, tokenDetail: RegisteredTokenDetail, pool: number }

function sortTokens(tokens: TokenDetail[], verifiedTokens: string[]) {
    const indexMap = new Map(verifiedTokens.map((value, index) => [value, index]));

    return tokens.sort((x, y) => {
        // Check if both elements are in array `a`
        const xInA = indexMap.has(x.tokenDetail.staking_address);
        const yInA = indexMap.has(y.tokenDetail.staking_address);

        if (xInA && yInA) {
            // If both are in array `a`, sort by their index in `a`
            return indexMap.get(x.tokenDetail.staking_address)! - indexMap.get(y.tokenDetail.staking_address)!;
        } else if (xInA) {
            // If only x is in array `a`, it should come first
            return -1;
        } else if (yInA) {
            // If only y is in array `a`, it should come first
            return 1;
        } else {
            // If neither is in array `a`, keep their original order (no change)
            return 0;
        }
    });
}

export function DashboardPage() {
    const [tokens, setTokens] = useState<TokenDetail[]>(JSON.parse(getTokenDetails()))
    const [previewToken, setPreviewToken] = useState<TokenDetail>()
    const [verifiedTokens, setVerifiedTokens] = useState<string[]>([])


    const loadRegisteredTokens = async () => {
        setTokens([])
        try {
            const { tokens }: RegisteredTokenResponse = await querySmartContract(FACTORY_ADDRESS, { registered_token: {} })
            const tokenDetails: TokenDetail[] = []

            for (const token of tokens) {
                try {
                    const tokenInfo: TokenInfoResponse = await querySmartContract(token.token_address, { token_info: {} })
                    const config: ConfigResponse = await querySmartContract(token.staking_address, { config: {} })
                    const { pool: { total_pool } }: PoolResponse = await querySmartContract(token.staking_address, { pool: {} })
                    const tokenDetail = { tokenInfo, config, tokenDetail: token, pool: Number(total_pool) };

                    tokenDetails.push(tokenDetail)
                    setTokens(prev => [...prev, tokenDetail])
                } catch { }
            }
            saveTokenDetails(JSON.stringify(tokenDetails))
        } catch (e) { }
    }


    const loadVerifiedTokens = async () => {
        const res = await fetch(VERIFIED_TOKENS_URL);
        const data = await res.json();
        setVerifiedTokens(data)
    }

    useEffect(() => {
        loadVerifiedTokens()
        if (tokens.length == 0) loadRegisteredTokens()
    }, [])

    return <div className="container-fluid container-p-y">
        <div className="row">
            <div className="col-12 col-md-6">
                <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between pb-0">
                        <div className="card-title mb-0">
                            <h5 className="m-0">Available to Stake</h5>
                            <small className="text-muted">Select the asset you want to stake</small>
                        </div>
                        <button onClick={loadRegisteredTokens} className="btn  btn-icon btn-outline-info">
                            <span className="bx bx-refresh"></span>
                        </button>
                    </div>
                    <div className="card-body">
                        <ul className="p-0 m-0">
                            {
                                sortTokens(tokens, verifiedTokens).map(e => <TokenItem
                                    isVerified={verifiedTokens.includes(e.tokenDetail.staking_address)}
                                    onShowModal={(p1, p2, p3, p4) => showTokenDetailModal(p3, p2, p1, p4)}
                                    onShowForm={(p1, p2, p3, p4) => setPreviewToken({ config: p2, tokenDetail: p1, tokenInfo: p3, pool: p4 })}
                                    key={e.tokenDetail.staking_address}
                                    pool={e.pool}
                                    config={e.config}
                                    tokenDetail={e.tokenDetail}
                                    tokenInfo={e.tokenInfo} />)
                            }
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 d-none d-md-block">
                <div className="card">
                    <div className="card h-100">
                        <div className="card-header d-flex align-items-center justify-content-between pb-0">
                            <div className="card-title mb-0">
                                <h5 className="">Token Detail</h5>
                            </div>
                        </div>
                        <div className="card-body">
                            <TokenDetailForm
                                pool={previewToken?.pool}
                                config={previewToken?.config}
                                tokenDetail={previewToken?.tokenDetail}
                                tokenInfo={previewToken?.tokenInfo}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}